import React from 'react';
import PropTypes from 'prop-types';

export const BwfiLayout = ({ children }) => {
  return (<div id="BestWorkplacesForInnovators__Application">{children}</div>)
};

BwfiLayout.propTypes = {
  children: PropTypes.any
}